import React, {
  PropsWithChildren,
  createContext,
  useContext,
  useState,
} from 'react';
import { Context } from './types';
import { FullscreenStripeLoader } from 'app/components/loaders';

const FullscreenStripeLoaderContext = createContext<Context>({} as Context);

export function FullscreenStripeLoaderProvider({
  children,
}: PropsWithChildren) {
  const [open, setIsOpen] = useState(false);

  function show() {
    setIsOpen(true);
  }

  function hide() {
    setIsOpen(false);
  }

  return (
    <FullscreenStripeLoaderContext.Provider
      value={{
        show,
        hide,
      }}
    >
      {children}

      {open && <FullscreenStripeLoader />}
    </FullscreenStripeLoaderContext.Provider>
  );
}

const useManageYourPlanDialog = () => useContext(FullscreenStripeLoaderContext);
export default useManageYourPlanDialog;
